import { fork, put, all, takeLatest, select } from "redux-saga/effects";
import _get from "lodash/get";

import {
  setStatus,
  fetchBoardingStatus,
  switchToProduction,
  requestApproval,
  updateStatusItem,
} from "../store/boardingSlice";

import {
  startLoading,
  setError,
  setSuccess,
  toggleEnvironment,
  selectEnvironment,
} from "../store/appSlice";

import { enqueueSnackbarSuccess } from "../store/appSlice";

import { callApi } from "./helpers/api";
import * as AccountsApi from "../api/Accounts";
import * as Clients from "../api/Clients";
import * as Payments from "../api/Payments";

import { STATUS_COMPLETED } from "../constants/transactionStatuses";
import { ENV_PRODUCTION, ENV_SANDBOX } from "../constants/environment";

function hasEntry(data) {
  return !!_get(data, "list[0]");
}

function* fetchBoardingStatusSaga() {
  const operationPath = "boarding";
  yield put(startLoading(operationPath));

  try {
    const appEnvinroment = yield select(selectEnvironment);

    switch (appEnvinroment) {
      case ENV_PRODUCTION: {
        const [clientsResult, accountResult] = yield all([
          yield callApi(Clients.getClients, { limit: 1 }),
          yield callApi(AccountsApi.getAccounts, { limit: 1 }),
        ]);
        const company = true;
        const account = hasEntry(accountResult);
        const client = hasEntry(clientsResult);
        const notification = true;

        yield put(
          setStatus({
            company,
            account,
            client,
            notification,
          })
        );
        break;
      }
      case ENV_SANDBOX:
      default: {
        const [clientsResult, transactionsResult] = yield all([
          yield callApi(Clients.getClients, { limit: 1 }),
          yield callApi(Payments.getPayments, {
            limit: 1,
            statuses: [STATUS_COMPLETED],
          }),
        ]);

        // todo
        const user = true;
        const client = hasEntry(clientsResult);
        const notification = true;
        const payment = hasEntry(transactionsResult);

        yield put(
          setStatus({
            user,
            client,
            notification,
            payment,
          })
        );
      }
    }

    yield put(setSuccess(operationPath));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* switchToProductionSaga() {
  const operationPath = "boarding";
  yield put(startLoading(operationPath));

  try {
    // to be changed when api endpoint will be done
    yield put(toggleEnvironment());
    yield put(
      enqueueSnackbarSuccess({
        code: "Your request to Volt was successfully send!",
      })
    );
    yield put(setSuccess(operationPath));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* requestApprovalSaga() {
  const operationPath = "boarding";
  yield put(startLoading(operationPath));

  try {
    // to be changed when api endpoint will be done
    // yield put(toggleEnvironment());

    yield put(
      updateStatusItem({
        key: "approval",
        value: true,
      })
    );

    yield put(
      enqueueSnackbarSuccess({
        code: "Your request to Volt was successfully send!",
      })
    );
    yield put(setSuccess(operationPath));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* watchFetchBoardingStatus() {
  yield takeLatest(fetchBoardingStatus().type, fetchBoardingStatusSaga);
}

function* watchSwitchToProduction() {
  yield takeLatest(switchToProduction().type, switchToProductionSaga);
}

function* watchRequestApproval() {
  yield takeLatest(requestApproval().type, requestApprovalSaga);
}

export default function* rootSaga() {
  yield all([fork(watchFetchBoardingStatus)]);
  yield all([fork(watchSwitchToProduction)]);
  yield all([fork(watchRequestApproval)]);
}
